import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useOrganizationsList() {
  // Use toast
  const toast = useToast()

  const refRefPriorityListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'name', sortable: true, label: 'Нэр' },
    { key: 'priority_point', sortable: true, label: 'Оноо' },
    { key: 'created_at', sortable: true, label: 'Үүсгэсэн огноо' },
    { key: 'created_by', sortable: true, label: 'Үүсгэсэн хэрэглэгч' },
    // { key: 'role', sortable: true, label: 'Эрх' },
    // {
    //   key: 'currentPlan',
    //   label: 'Групп',
    //   formatter: title,
    //   sortable: true,
    // },
    { key: 'is_active', sortable: true, label: 'Төлөв' },
    { key: 'actions', label: 'Үйлдэл' },
  ]
  const perPage = ref(10)
  const totalOrganizations = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refRefPriorityListTable.value ? refRefPriorityListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalOrganizations.value,
    }
  })

  const refetchData = () => {
    refRefPriorityListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchRefPriorities = (ctx, callback) => {
    store
      .dispatch('app-ref-priority/fetchRefPriorities', {
        // q: searchQuery.value,
        // perPage: perPage.value,
        // page: currentPage.value,
        // sortBy: sortBy.value,
        // sortDesc: isSortDirDesc.value,
        // role: roleFilter.value,
        // plan: planFilter.value,
        // status: statusFilter.value,
      })
      .then(response => {
        // const { organizations, total } = response.data
        const organizations = response.data.response
        const total = 10
        // const organizationa = organizations.map(x => (x.status === 'active') ? x.statusText = 'Идэвхитэй' : (x.status === 'inactive') ? x.statusText = 'Идэвхигүй' : x.statusText = 'Хүлээгдэж буй')
        callback(response.data.response)
        totalOrganizations.value = total
      })
      .catch(error => {
        console.log(error)
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching organizations list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveOrganizationRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveOrganizationRoleIcon = role => {
    if (role === 'subscriber') return 'OrganizationIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'OrganizationIcon'
  }

  const resolveOrganizationStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchRefPriorities,
    tableColumns,
    perPage,
    currentPage,
    totalOrganizations,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refRefPriorityListTable,

    resolveOrganizationRoleVariant,
    resolveOrganizationRoleIcon,
    resolveOrganizationStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
